export const environment = {
  production: false,
  /**
   * Deployed development environment. Mirrors
   * vaseline-frontend/src/environments/environment.development.ts so the
   * admin and consumer sites build against the same dev backend.
   *
   * TODO: confirm both hostnames match the actual dev deployments.
   */
  apiUrl: 'https://vaseline-api.redeem.ph',
  consumerSiteUrl: 'https://vaseline.redeem.ph',
};
